import React from "react"

import { LANGUAGE } from "actions/constants"

export default {
    [LANGUAGE.EN]: [
        {
            Type: () => <>Entering Thailand</>,
            Title: () => null,
            Address: null,
            Phone: null,
            Details: () => (
                <>
                    <p>
                        Items Required for Entry into Thailand for Customs Inspection
                        <ol>
                          <li>Hotel accommodation itinerary after entry</li>
                          <li>Retun flight itinerary</li>
			  <li>10,000 Thai Baht in cash per person</li>
                          <li>Complete the online electronic arrival card within 3 days before entry (<a href="https://tdac.immigration.go.th/arrival-card/#/home">here</a>)</li>
                        </ol>
                        All of the above can be in electronic format.
                    </p>
                </>
            ),
            link: "https://th.usembassy.gov/notice-thailand-digital-arrival-card-system-set-to-launch-on-1-may-2025/",
        },
        {
            Type: () => <>Do we really need to do all that?</>,
            Title: () => null,
            Address: null,
            Phone: null,
            Details: () => (
                <>
                    <p> Here's a message from our wedding planner about this: 
                    <br />
❗❗Reminder: Many friends often ask if it’s okay not to prepare the above because it seems troublesome. Since the above materials are officially required by the Thai Immigration Bureau, sometimes customs officers may not check and let you pass directly, but sometimes they can be very strict. If you are checked and do not have the required documents, it can cause trouble with entry and, in serious cases, even lead to deportation. Therefore, it is strongly recommended to comply with Thai regulations and prepare accordingly❗❗
<br />
⭐⭐ You must fill out the Thai electronic arrival card online within 3 days before entry.
Filing website: <a href="https://tdac.immigration.go.th/arrival-card/#/home"> https://tdac.immigration.go.th/arrival-card/#/home </a>
This is the only official website. If it cannot be opened due to network issues, you must try repeatedly or switch networks. If you still cannot open it, you can only fill it out at the on-site machine after landing in Thailand, which may take around 30 minutes to 1 hour.
                    </p>
                </>
            ),
            link: null,
        },
        {
            Type: () => <>Chiang Mai</>,
            Details: () => (
                <>
                    <p>
                        Chiang Mai is the largest city in Northern Thailand.
                        It's known for its historical temples, beautiful mountains, 
                        vibrant night markets, and rich cultural heritage.
                    </p>
                </>
            ),
            link: "https://www.tourismthailand.org/Destinations/Provinces/Chiang-Mai/101",
        },
        {
            Type: () => <>Flight</>,
            Title: () => <>Airport Code: CNX</>,
            Address: null,
            Phone: null,
            Details: () => (
                <>
                    <p>Chaing Mai International Airport is the local airport.</p>
                </>
            ),
            link:
                "https://www.google.com/travel/flights/flights-to-chiang-mai.html?gl=US&hl=en-US",
        },
        {
            Type: () => <>Getting around</>,
            Title: () => null,
            Address: null,
            Phone: null,
            Details: () => (
                <>
                    <p>Ride sharing apps Grab and Bolt are popular in Chiang Mai.
                       Taxis and tuk-tuks are also plentiful.  It's not possible
                       to rent a car without an international driver’s license (IDP).
                    </p>
                </>
            ),
            link: "https://www.grab.com/sg/",
        },
        {
            Type: () => <>Lodging for the Wedding</>,
            Title: () => <>Chiang Mai</>,
            Address: null,
            Phone: null,
            Details: () => (
                <>
                    <p>
                        Our wedding venue (Kaomai Lanna Resort) is about 40 minutes south of Chiang Mai. It’s beautiful and peaceful, but there’s not much going on 
outside the resort. So if you're coming a few days before or staying after the wedding, we’d recommend staying in Downtown Chiang Mai — it's way easier to get to fun 
stuff like temples, night markets, and shopping. 
There are lots of great hotels downtown, like Anantara Chiang Mai Resort, Aksara Heritage, Na Nirand Romantic Boutique Resort, 137 Pillars, and Bella Nara Hotel.       
                    </p>
                </>
            ),
            link: null,
        },
    ],
    [LANGUAGE.ZH]: [
        {
            Type: () => <>入境泰国</>,
            Title: () => null,
            Address: null,
            Phone: null,
            Details: () => (
                <>
                    <p>
                        入境泰国海关检查所需物品

<ol>
<li>入境后的酒店住宿行程单</li>
<li>返程航班行程单</li>
<li>每人10,000泰铢现金</li>
<li>在入境前3天内完成在线电子入境卡填写（<a href="https://tdac.immigration.go.th/arrival-card/#/home">此处</a>）</li>
</ol>
以上所有文件均可使用电子版。
                    </p>
                </>
            ),
            link: "https://tdac.immigration.go.th/arrival-card/#/home",
        },
        {
            Type: () => <>我们真的需要准备所有这些东西吗？</>,
            Title: () => null,
            Address: null,
            Phone: null,
            Details: () => (
                <>
                    <p> 这是我们的婚礼策划师对此的留言： 
                    <br />
❗❗提示：经常有朋友问觉得上面准备的内容太麻烦，可不可以不准备？因为以上资料为泰国移民局入境官方要求，某些海关可能不查直接放行，某些海关可能会很严格，一旦被查到且没有准备的情况下就会造成入境的麻烦，严重甚至遣返，所以个人建议还是要遵守泰国法规相应准备一下❗❗
<br />
⭐⭐需在入境前3天内在线填报泰国电子入境卡，填报网址：<a href="https://tdac.immigration.go.th/arrival-card/#/home"> https://tdac.immigration.go.th/arrival-card/#/home </a>。

此网站为唯一登录网站，如遇网络原因无法打开，需反复尝试或更换网络尝试，如始终无法打开，那么只能在落地泰国的时候现场在机器上填写，大概会现场耗时30分钟至一小时
                    </p>
                </>
            ),
            link: null,
        },
        {
            Type: () => <>清迈</>,
            Details: () => (
                <>
                    <p>
                        清迈是泰国北部最大的城市，以古老的寺庙，美丽的山丘，充满活力的夜市和丰富的文化传承闻名。
                    </p>
                </>
            ),
            link: "https://www.tourismthailand.org/Destinations/Provinces/Chiang-Mai/101",
        },
        {
            Type: () => <>航班</>,
            Title: () => <>机场代码CNX</>,
            Address: null,
            Phone: null,
            Details: () => (
                <>
                    <p>清迈国际机场是泰国本地机场，从中国或美国没有直达飞机。</p>
                </>
            ),
            link:
                "https://www.google.com/travel/flights/flights-to-chiang-mai.html?gl=US&hl=en-US",
        },
        {
            Type: () => <>交通工具</>,
            Title: () => null,
            Address: null,
            Phone: null,
            Details: () => (
                <>
                    <p>打车软件：Grab 和 Bolt 在清迈很常用.
                       出租车和突突车也很常见。在清迈租车自驾比较麻烦，不推荐。
                    </p>
                </>
            ),
            link: "https://www.grab.com/sg/",
        },
        {
            Type: () => <>现金要求</>,
            Title: () => null,
            Address: null,
            PhonAe: null,
            Details: () => (
                <>
                    <p>
                        
所有旅游签入境泰国的外国人都被强烈建议携带足够的泰铢现金。建议的额度是：单人一万泰铢（约合2200人民币），或是每个家庭共两万泰铢（合计约4400人民币）。泰国海关会进行随机抽查.
                    </p>
                </>
            ),
            link: null,
        },
        {
            Type: () => <>婚礼住宿</>,
            Title: () => <>清迈i</>,
            Address: null,
            Phone: null,
            Details: () => (
                <>
                    <p>
我们的婚礼场地（Kaomai Lanna 
Resort）位于清迈市区以南大约40分钟车程的地方。那里非常美丽宁静，但度假村周边没有太多娱乐活动。如果你们计划在婚礼前几天到达或婚礼后多待几天，我们建议大家可以住在清迈市中心，那里的交通更方便，也更容易去逛庙宇、夜市和商场之类的好玩地方！
市中心有很多很棒的酒店，例如：</p>
<p>Anantara Chiang Mai Resort</p>
<p>Aksara Heritage</p>
<p>Na Nirand Romantic Boutique Resort</p>
<p>137 Pillars</p>
<p>Bella Nara Hotel</p>
                </>
            ),
            link: null,
        },
    ],
}
